import { render, staticRenderFns } from "./ReportSellerQuotationsModal.vue?vue&type=template&id=054b0524&scoped=true"
import script from "./ReportSellerQuotationsModal.vue?vue&type=script&lang=js"
export * from "./ReportSellerQuotationsModal.vue?vue&type=script&lang=js"
import style0 from "./ReportSellerQuotationsModal.vue?vue&type=style&index=0&id=054b0524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b0524",
  null
  
)

export default component.exports